<template>
  <div class="modal outside-country" v-show="getInfoPopup && !isInfoSeen">
    <div class="modal__content">
      <div class="modal__main">
        <div class="modal__row">
          <svg viewBox="0 0 254 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3706_3319)">
              <path
                  d="M92.5433 2.91275C7.14036 20.2019 -19.0838 128.951 72.3186 174.085C73.2866 174.562 74.2901 174.988 75.2976 175.43C176.038 219.539 212.278 198.785 234.464 156.31C260.066 107.294 209.992 -20.8645 92.5433 2.91275Z"
                  fill="#69B6C7" fill-opacity="0.5"/>
              <path
                  d="M176.999 51.8369C177.568 51.4262 178.452 51.395 179.372 51.7197C180.285 52.0419 181.091 52.668 181.463 53.3545C183.075 56.3308 184.24 60.1403 185.748 64.9551C187.251 69.7532 189.081 75.5005 192.019 82.2783C193.122 84.8261 194.888 91.1512 196.387 96.8877C197.133 99.7457 197.811 102.443 198.301 104.425C198.546 105.415 198.744 106.228 198.881 106.792C198.949 107.074 199.003 107.295 199.039 107.444C199.057 107.519 199.071 107.577 199.08 107.615C199.085 107.634 199.089 107.649 199.091 107.658C199.091 107.66 199.091 107.662 199.092 107.664V107.665C202.763 124.275 201.857 136.003 198.924 176.697L177.34 198.307L176.628 197.653L176.594 197.622L176.554 197.598L175.871 197.185C172.491 195.208 169.642 194.53 167.027 194.485C164.266 194.439 161.777 195.105 159.308 195.614C156.821 196.127 154.297 196.5 151.332 195.954C148.552 195.442 145.345 194.115 141.404 191.271L140.606 190.682L140.224 190.382C138.302 188.819 136.215 186.297 134.07 183.207C131.789 179.921 129.468 176.03 127.241 172.051C125.015 168.072 122.887 164.014 120.987 160.395C119.091 156.781 117.418 153.594 116.109 151.376L100.574 125.04L127.197 75.0879L175.609 101.1L176.404 101.527L176.345 100.626V100.616C176.344 100.61 176.344 100.6 176.343 100.588C176.341 100.563 176.338 100.525 176.335 100.477C176.328 100.379 176.319 100.235 176.307 100.052C176.282 99.6858 176.246 99.1621 176.201 98.5312C176.112 97.2695 175.99 95.578 175.854 93.8604C175.719 92.1436 175.57 90.3976 175.43 89.0273C175.359 88.3428 175.291 87.7468 175.227 87.2939C175.194 87.0682 175.162 86.8723 175.13 86.7158C175.102 86.579 175.065 86.4162 175.007 86.2979C165.205 66.4934 173.25 54.5388 176.999 51.8369Z"
                  fill="#FFEEC3" stroke="#3C1053"/>
              <mask id="mask0_3706_3319" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="15" y="-1" width="226"
                    height="201">
                <path
                    d="M92.5833 2.91179C7.27398 20.201 -18.9215 128.951 72.3807 174.085C73.3476 174.562 74.3501 174.988 75.3565 175.43C175.986 219.539 212.186 198.785 234.348 156.31C259.922 107.293 209.903 -20.8656 92.5833 2.91179Z"
                    fill="#EFEBFF"/>
              </mask>
              <g mask="url(#mask0_3706_3319)">
                <path d="M138.777 183.271L140.698 260.215H210.814L199.906 169.878L138.777 183.271Z" fill="#FFEEC3"/>
                <path d="M209.601 254.806L199.649 169.965" stroke="#3C1053" stroke-linecap="round"/>
              </g>
              <path d="M180.001 183C180.001 183 165.425 154.491 173.372 125" stroke="#3C1053" stroke-linecap="round"
                    stroke-linejoin="round"/>
              <path
                  d="M58.252 65.9043C60.4751 64.1282 63.7688 62.8238 68.4951 63.8779C73.2508 64.9388 79.4924 68.3963 87.543 76.2539C94.1768 82.7299 97.5075 87.2815 98.8174 90.4502C99.4699 92.0287 99.6038 93.2238 99.4336 94.125C99.266 95.0122 98.7941 95.6658 98.1221 96.1572C96.7368 97.1699 94.5255 97.4747 92.5654 97.498C91.6016 97.5095 90.7285 97.4531 90.0967 97.3936C89.7812 97.3638 89.5263 97.3334 89.3516 97.3105C89.2903 97.3025 89.239 97.2948 89.1982 97.2891L59.2803 75.3848C57.638 73.923 56.7117 72.0694 56.5332 70.3271C56.3548 68.5846 56.9209 66.9675 58.252 65.9043Z"
                  fill="#FFEEC3" stroke="#3C1053"/>
              <path d="M191.253 163L194.001 156.959L67.6874 37L65.001 42.8831L191.253 163Z" fill="#3C1053"/>
              <path
                  d="M131.491 178.824L186.025 167.855C191.166 166.822 193.431 161.465 191.06 155.951L139.168 35.3191C136.798 29.8052 130.651 26.1412 125.51 27.1744L70.9769 38.1426C65.8359 39.1759 63.5714 44.5328 65.9422 50.0467L117.833 170.681C120.204 176.195 126.351 179.859 131.491 178.826V178.824Z"
                  fill="#AB1D75" stroke="#3C1053"/>
              <path
                  d="M128.609 21.665C131.031 21.1783 133.727 21.7929 136.122 23.2207C138.514 24.6472 140.568 26.864 141.709 29.5166L193.601 150.148C194.741 152.8 194.75 155.375 193.898 157.389C193.05 159.394 191.335 160.881 188.927 161.365L134.393 172.333L134.324 172.346C131.92 172.808 129.252 172.194 126.88 170.779C124.637 169.442 122.692 167.41 121.518 164.976L121.293 164.483L69.4014 43.8496C68.2614 41.1982 68.252 38.6232 69.1035 36.6094C69.9516 34.6038 71.6672 33.1168 74.0752 32.6328L128.609 21.665Z"
                  fill="#AB1D75" stroke="#3C1053"/>
              <path
                  d="M98.1904 134.617C99.0874 134.403 100.171 134.492 101.354 134.799C103.719 135.413 106.303 136.853 108.189 138.06C110.39 139.467 112.119 142.164 112.446 145.123L112.474 145.41C112.635 147.459 112.13 149.46 110.041 150.657C108.774 151.383 106.859 151.655 104.756 151.414C102.664 151.175 100.45 150.435 98.6191 149.214C96.7899 147.994 95.3624 146.309 94.7832 144.183C94.2055 142.061 94.4529 139.427 96.1045 136.267C96.596 135.326 97.3166 134.826 98.1904 134.617Z"
                  fill="#FFEEC3" stroke="#3C1053"/>
              <path
                  d="M89.1328 116.458C91.1075 114.993 93.7352 115.345 96.4736 116.594C99.1895 117.832 101.848 119.881 103.721 121.509C105.916 123.417 106.989 126.314 106.287 129.025L106.214 129.285C105.93 130.221 105.444 131.109 104.649 131.827C103.906 132.499 102.869 133.045 101.417 133.327L101.121 133.38C99.1998 133.694 96.6652 133.384 94.1309 132.562C91.6016 131.743 89.1267 130.431 87.3184 128.797C85.5064 127.159 84.4167 125.249 84.5059 123.218C84.5949 121.19 85.8654 118.881 89.1328 116.458Z"
                  fill="#FFEEC3" stroke="#3C1053"/>
              <path
                  d="M83.9307 99.4521C85.8043 97.999 88.2986 98.3429 90.915 99.5898C93.509 100.826 96.0498 102.874 97.8408 104.501C99.9374 106.406 100.969 109.308 100.296 112.03L100.226 112.291C99.9536 113.23 99.4876 114.119 98.7295 114.835C97.9737 115.549 96.8997 116.118 95.3691 116.38C93.5409 116.692 91.1246 116.384 88.7041 115.564C86.2889 114.746 83.924 113.436 82.1963 111.804C80.4667 110.169 79.4201 108.257 79.5059 106.217C79.5914 104.181 80.8107 101.872 83.9307 99.4521Z"
                  fill="#FFEEC3" stroke="#3C1053"/>
              <path
                  d="M183.72 152.577L130.9 162.869C127.487 163.534 123.635 161.599 122.341 158.57L73.4305 44.1403C72.1361 41.1098 73.8673 38.0873 77.2805 37.4232L130.1 27.1307C133.513 26.4666 137.365 28.3994 138.659 31.4298L187.571 145.86C188.866 148.89 187.135 151.913 183.721 152.577H183.72Z"
                  fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M116.001 81.1459L117.887 81C117.887 81 118.525 84.5738 116.781 83.9201C116.411 83.7824 116.001 81.1459 116.001 81.1459Z"
                    fill="white"/>
              <path
                  d="M100.065 92.764C100.796 91.865 101.994 89.952 101.707 87.3177C101.669 86.9686 102.179 86.8787 102.401 87.1923C103.556 88.8251 105.43 90.8908 107.585 91.0329C107.9 91.0538 108.113 91.3779 107.938 91.5849C106.874 92.8539 106.372 94.6624 106.825 97.6625C106.88 98.0326 106.331 98.133 106.12 97.788C104.951 95.8604 103.007 93.5167 100.391 93.3222C100.083 93.2992 99.8967 92.9689 100.063 92.764H100.065Z"
                  fill="white"/>
              <path
                  d="M139.611 137.5C141.133 143.299 138.063 148 132.755 148C127.446 148 121.91 143.299 120.391 137.5C118.869 131.701 121.939 127 127.247 127C132.556 127 138.092 131.701 139.611 137.5Z"
                  fill="#69B6C7" fill-opacity="0.5"/>
              <path
                  d="M176.258 126.434L144.984 131.981C144.317 132.099 143.49 131.652 143.149 130.989C142.809 130.325 143.074 129.684 143.744 129.566L175.018 124.019C175.685 123.901 176.512 124.348 176.853 125.011C177.193 125.675 176.927 126.316 176.258 126.434Z"
                  fill="#69B6C7" fill-opacity="0.5"/>
              <path
                  d="M162.216 137.028L148.097 139.977C147.391 140.123 146.518 139.567 146.158 138.742C145.798 137.916 146.079 137.119 146.786 136.972L160.905 134.023C161.611 133.877 162.484 134.433 162.844 135.258C163.204 136.084 162.923 136.881 162.216 137.028Z"
                  fill="#69B6C7" fill-opacity="0.5"/>
              <path
                  d="M127.592 107C129.189 112.523 125.966 117 120.392 117C114.818 117 109.006 112.523 107.41 107C105.813 101.477 109.036 97 114.61 97C120.184 97 125.996 101.477 127.592 107Z"
                  fill="#69B6C7" fill-opacity="0.5"/>
              <path
                  d="M163.258 95.7379L131.984 101.979C131.317 102.111 130.49 101.609 130.149 100.862C129.809 100.116 130.074 99.3946 130.744 99.2621L162.018 93.0212C162.685 92.8887 163.512 93.3913 163.853 94.1377C164.193 94.8842 163.927 95.6054 163.258 95.7379Z"
                  fill="#69B6C7" fill-opacity="0.5"/>
              <path
                  d="M149.262 106.523L135.973 108.98C135.31 109.103 134.487 108.639 134.148 107.951C133.81 107.264 134.074 106.599 134.74 106.477L148.029 104.02C148.692 103.897 149.515 104.361 149.853 105.049C150.192 105.736 149.928 106.401 149.262 106.523Z"
                  fill="#69B6C7" fill-opacity="0.5"/>
              <path
                  d="M109.592 70.5C111.189 76.2991 107.966 81 102.392 81C96.8181 81 91.0055 76.2991 89.41 70.5C87.8126 64.7009 91.0356 60 96.6097 60C102.184 60 107.996 64.7009 109.592 70.5Z"
                  fill="#69B6C7" fill-opacity="0.5"/>
              <path
                  d="M145.258 59.4337L113.984 64.9812C113.317 65.0989 112.49 64.6522 112.149 63.9887C111.809 63.3251 112.074 62.6841 112.744 62.5663L144.018 57.0188C144.685 56.9011 145.512 57.3478 145.853 58.0113C146.193 58.6749 145.927 59.316 145.258 59.4337Z"
                  fill="#69B6C7" fill-opacity="0.5"/>
              <path
                  d="M131.262 70.0279L117.973 72.9766C117.31 73.1231 116.487 72.5673 116.148 71.7418C115.81 70.9162 116.074 70.1186 116.74 69.9721L130.029 67.0234C130.692 66.8769 131.515 67.4327 131.853 68.2582C132.192 69.0838 131.928 69.8814 131.262 70.0279Z"
                  fill="#69B6C7" fill-opacity="0.5"/>
              <path
                  d="M120.914 77.4786L164.352 67.7236C176.061 65.0933 181.98 53.2227 177.508 41.3422C173.036 29.4618 159.797 21.8931 148.088 24.5215L104.65 34.2764C92.9413 36.9067 87.0217 48.7773 91.494 60.6578C95.9663 72.5382 109.205 80.1069 120.914 77.4786Z"
                  fill="#C4D600"/>
              <path d="M112.001 75.1547L114.449 90L129.001 74L112.001 75.1547Z" fill="#C4D600"/>
              <path
                  d="M131.295 46.9393L133.194 46.521L131.313 45.4588C131.262 45.4299 131.22 45.3856 131.198 45.3354C130.63 44.0612 131.697 43.4598 132.54 43.9379L134.04 44.7841L133.278 42.8622C133.258 42.8121 133.256 42.7562 133.276 42.7099C133.757 41.5707 135.087 41.9504 135.429 42.8121L136.036 44.3427L136.841 42.6887C136.862 42.6444 136.903 42.6116 136.951 42.5981C138.2 42.2589 139.015 43.3981 138.654 44.1422L138.014 45.4607L139.913 45.0424C139.963 45.0309 140.022 45.0386 140.072 45.0656C141.356 45.7268 141.18 46.9586 140.326 47.1455L138.811 47.479L140.695 48.5412C140.745 48.5701 140.788 48.6144 140.809 48.6646C141.377 49.9388 140.311 50.5402 139.467 50.0621L137.968 49.2159L138.73 51.1378C138.749 51.1879 138.751 51.2438 138.732 51.2901C138.251 52.4293 136.92 52.0496 136.579 51.1879L135.972 49.6573L135.167 51.3113C135.145 51.3556 135.105 51.3884 135.056 51.4019C133.807 51.7411 132.992 50.6 133.353 49.8578L133.995 48.5393L132.48 48.8728C131.627 49.0597 130.579 48.0978 131.177 47.0241C131.2 46.9817 131.245 46.9508 131.295 46.9393Z"
                  fill="white"/>
              <path
                  d="M119.295 49.9393L121.194 49.521L119.313 48.4588C119.262 48.4299 119.22 48.3856 119.198 48.3354C118.63 47.0612 119.697 46.4598 120.54 46.9379L122.04 47.7841L121.278 45.8622C121.258 45.8121 121.256 45.7562 121.276 45.7099C121.757 44.5707 123.087 44.9504 123.429 45.8121L124.036 47.3427L124.841 45.6887C124.862 45.6444 124.903 45.6116 124.951 45.5981C126.2 45.2589 127.015 46.3981 126.654 47.1422L126.014 48.4607L127.913 48.0424C127.963 48.0309 128.022 48.0386 128.072 48.0656C129.356 48.7268 129.18 49.9586 128.326 50.1455L126.811 50.479L128.695 51.5412C128.745 51.5701 128.788 51.6144 128.809 51.6646C129.377 52.9388 128.311 53.5402 127.467 53.0621L125.968 52.2159L126.73 54.1378C126.749 54.1879 126.751 54.2438 126.732 54.2901C126.251 55.4293 124.92 55.0496 124.579 54.1879L123.972 52.6573L123.167 54.3113C123.145 54.3556 123.105 54.3884 123.056 54.4019C121.807 54.7411 120.992 53.6 121.353 52.8578L121.995 51.5393L120.48 51.8728C119.627 52.0617 118.579 51.0978 119.177 50.0241C119.2 49.9817 119.245 49.9508 119.295 49.9393Z"
                  fill="white"/>
              <path
                  d="M106.295 52.4332L108.194 51.9731L106.313 50.8047C106.262 50.7729 106.22 50.7241 106.198 50.669C105.63 49.2674 106.697 48.6058 107.54 49.1317L109.04 50.0625L108.277 47.9484C108.258 47.8933 108.256 47.8318 108.276 47.7809C108.757 46.5277 110.087 46.9455 110.429 47.8933L111.036 49.577L111.841 47.7576C111.862 47.7088 111.903 47.6728 111.951 47.6579C113.2 47.2847 114.015 48.5379 113.654 49.3564L113.014 50.8068L114.913 50.3467C114.963 50.334 115.022 50.3424 115.072 50.3721C116.356 51.0994 116.18 52.4544 115.326 52.6601L113.811 53.0269L115.695 54.1953C115.745 54.2271 115.788 54.2759 115.809 54.331C116.377 55.7326 115.311 56.3942 114.467 55.8683L112.968 54.9375L113.73 57.0516C113.749 57.1067 113.751 57.1682 113.732 57.2191C113.251 58.4723 111.92 58.0545 111.579 57.1067L110.972 55.423L110.167 57.2424C110.145 57.2912 110.105 57.3272 110.056 57.3421C108.807 57.7153 107.992 56.4599 108.353 55.6436L108.995 54.1932L107.48 54.56C106.627 54.7657 105.579 53.7076 106.177 52.5265C106.2 52.4799 106.245 52.4459 106.295 52.4332Z"
                  fill="white"/>
              <path
                  d="M157.295 40.9393L159.194 40.521L157.313 39.4588C157.262 39.4299 157.22 39.3856 157.198 39.3354C156.63 38.0612 157.697 37.4598 158.54 37.9379L160.04 38.7841L159.277 36.8622C159.258 36.8121 159.256 36.7562 159.276 36.7099C159.757 35.5707 161.087 35.9504 161.429 36.8121L162.036 38.3427L162.841 36.6887C162.862 36.6444 162.903 36.6116 162.951 36.5981C164.2 36.2589 165.015 37.3981 164.654 38.1422L164.014 39.4607L165.913 39.0424C165.963 39.0309 166.022 39.0386 166.072 39.0656C167.356 39.7268 167.18 40.9586 166.326 41.1455L164.811 41.479L166.695 42.5412C166.745 42.5701 166.788 42.6144 166.809 42.6646C167.377 43.9388 166.311 44.5402 165.467 44.0621L163.968 43.2159L164.73 45.1378C164.749 45.1879 164.751 45.2438 164.732 45.2901C164.251 46.4293 162.92 46.0496 162.579 45.1879L161.972 43.6573L161.167 45.3113C161.145 45.3556 161.105 45.3884 161.056 45.4019C159.807 45.7411 158.992 44.6 159.353 43.8578L159.995 42.5393L158.48 42.8727C157.627 43.0597 156.579 42.0978 157.177 41.0241C157.2 40.9817 157.245 40.9508 157.295 40.9393Z"
                  fill="white"/>
              <path
                  d="M144.295 43.9393L146.194 43.521L144.313 42.4588C144.262 42.4299 144.22 42.3856 144.198 42.3354C143.63 41.0612 144.697 40.4598 145.54 40.9379L147.04 41.7841L146.277 39.8622C146.258 39.8121 146.256 39.7562 146.276 39.7099C146.757 38.5707 148.087 38.9504 148.429 39.8121L149.036 41.3427L149.841 39.6887C149.862 39.6444 149.903 39.6116 149.951 39.5981C151.2 39.2589 152.015 40.3981 151.654 41.1422L151.014 42.4607L152.913 42.0424C152.963 42.0309 153.022 42.0386 153.072 42.0656C154.356 42.7268 154.18 43.9586 153.326 44.1455L151.811 44.479L153.695 45.5412C153.745 45.5701 153.788 45.6144 153.809 45.6646C154.377 46.9388 153.311 47.5402 152.467 47.0621L150.968 46.2159L151.73 48.1378C151.749 48.1879 151.751 48.2438 151.732 48.2901C151.251 49.4293 149.92 49.0496 149.579 48.1879L148.972 46.6573L148.167 48.3113C148.145 48.3556 148.105 48.3884 148.056 48.4019C146.807 48.7411 145.992 47.6 146.353 46.8578L146.995 45.5393L145.48 45.8727C144.627 46.0597 143.579 45.0978 144.177 44.0241C144.2 43.9817 144.245 43.9508 144.295 43.9393Z"
                  fill="white"/>
              <path
                  d="M127.001 70L161.601 62.9961C164.672 62.3746 167.592 61.0844 170.045 59.1077C173.181 56.5823 176.132 52.5877 174.569 47"
                  stroke="#3C1053"/>
              <path d="M156.001 22L151.001 4" stroke="#3C1053"/>
              <path d="M171.001 22L176.001 5" stroke="#3C1053"/>
              <path d="M182.001 28L198.001 19" stroke="#3C1053"/>
              <path d="M97.001 104.126C93.1093 103.244 88.2447 107.006 92.9147 115" stroke="#3C1053"
                    stroke-linecap="round"/>
              <path d="M101.001 121.114C97.7579 120.313 93.7041 123.733 97.5957 131" stroke="#3C1053"
                    stroke-linecap="round"/>
              <path d="M109.001 140.114C105.758 139.313 101.704 142.733 105.596 150" stroke="#3C1053"
                    stroke-linecap="round"/>
            </g>
            <defs>
              <clipPath id="clip0_3706_3319">
                <rect width="254" height="200" fill="white"/>
              </clipPath>
            </defs>
          </svg>

          <div class="modal__col">
            <p class="modal__col-title modal__col-title--first">Шановні учасники програми!</p>
            <p class="modal__col-text modal__col-text--first">Інформуємо, що починаючи з жовтня 2025 року в межах
              програми підтримки пацієнтів
              «ТерапіяПЛЮС» буде запроваджено смс-веріфікацію учасників програми.</p>
          </div>
        </div>

        <div class="modal__row modal__row--flexStart">

          <div class="modal__col">
            <p class="modal__col-title">Як це працюватиме?</p>
            <p class="modal__col-text">Працівник аптеки, яка бере участь у Програмі, повинен: </p>
          </div>

          <div class="modal__col">
            <p class="modal__col-list"><span>Відсканувати</span> штрих-код картки учасника Програми. </p>
            <p class="modal__col-text modal__col-text--small modal__col-text--mb20">Після цього на мобільний номер
              телефону учасника Програми
              автоматично надходить
              смс–повідомлення з кодом перевірки.</p>

            <p class="modal__col-list">Учасник Програми повинен <span>надати код перевірки працівнику аптеки,</span>
              який вносить його до системи.</p>
            <p class="modal__col-text modal__col-text--small">Придбання лікарського засобу зі знижкою (за зниженою
              вартістю), встановленою
              відповідно до умов Програми, можливе після успішної верифікації коду перевірки.</p>
          </div>
        </div>

        <div class="modal__row modal__row--column">
          <p><span>З усіма питаннями</span> ви можете звернутись на гарячу лінію
            <span>за номером телефона 0 800 211 202</span> (щоденно з 9:00 до 21:00, дзвінки з усіх телефонних номерів в
            межах України безкоштовні).</p>
          <p>Дякуємо! З повагою, Компанія «АстраЗенека Україна», Організатор програми підтримки пацієнтів
            «ТерапіяПЛЮС»</p>
        </div>

        <div class="modal__close" @click="closeModal"></div>
        <div class="modal__closeBtn" @click="closeModal">Закрити</div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "info",
  data() {
    return {
      isInfoSeen: false
    };
  },
  created() {
    // Перевіряємо localStorage при створенні компонента
    this.isInfoSeen = localStorage.getItem("info") === "true";
  },
  computed: {
    ...mapGetters(["getInfoPopup"])
  },
  methods: {
    ...mapMutations(["setInfoPopUp"]),
    closeModal() {
      this.setInfoPopUp(false);
      localStorage.setItem("info", "true");
      this.isInfoSeen = true;
    },
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  z-index: 999999999999999;

  &__main {
    width: 100%;
    max-width: 100%;
  }

  &__content {
    overflow-y: auto;
    max-width: 1110px;
    width: 100%;
    padding: 24px 0 48px 0;

    position: relative;
    left: initial;
    top: initial;
    transform: initial;
    @media screen and (min-width: 1024px) and (max-height: 924px) {
      max-height: 90vh;
    }

    @media screen and (max-width: 1024px) {
      max-height: 90vh;
    }

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(105, 182, 199, 0.3);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #69B6C7;
      border-radius: 16px;
    }
  }

  &__row {
    display: grid;
    grid-template-columns: 256px 1fr;
    grid-gap: 30px;
    align-items: center;
    padding: 0 142px;

    @media screen and (max-width: 1024px) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0 60px;
    }
    @media screen and (max-width: 768px) {
      padding: 0 20px;

    }

    svg {
      max-width: 256px;
      min-width: 256px;
      width: 100%;
      height: auto;


      @media screen and (max-width: 768px) {
        min-width: 1px;
      }
    }

    &--flexStart {
      align-items: flex-start;
      background: rgba(105, 182, 199, 0.10);
      padding: 40px 142px;
      @media screen and (max-width: 1024px) {
        padding: 24px 60px;
        margin-top: 24px;
      }
      @media screen and (max-width: 768px) {
        padding: 24px 20px;
      }
    }

    &--column {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      grid-gap: 10px;
      margin-top: 40px;

      @media screen and (max-width: 768px) {
        margin-top: 24px;
      }

      p {

        color: #AB1D75;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;

        span {
          font-weight: 700;
        }
      }
    }
  }

  &__col {
    width: 100%;
    display: flex;
    flex-direction: column;

    &-text {
      color: #3C1053;

      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      &--mb20 {
        margin-bottom: 20px;

        @media screen and (max-width: 768px) {
          margin-bottom: 16px;
        }

      }

      @media screen and (max-width: 768px) {
        font-size: 16px;
      }

      &--small {
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }
    }

    &-list {
      color: #3C1053;

      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
      position: relative;
      padding-left: 16px;
      margin-bottom: 8px;

      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 8px;

        width: 8px;
        height: 8px;
        background: #AB1D75;
        border-radius: 50%;
      }

      span {
        font-weight: 700;

      }
    }

    &-title {
      color: #AB1D75;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 130%;
      margin-bottom: 8px;

      &--first {
        margin-bottom: 15px;
        color: #3C1053;
      }
    }
  }

  &__closeBtn {
    padding: 22px 36px;
    background: #ffd770;
    border: 1px solid #f0ab00;
    border-radius: 2px;
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: #3c1053;
    cursor: pointer;
    max-width: 253px;
    display: flex;
    justify-content: center;
    align-items: center;

    margin: 40px auto 0 auto;

    @media screen and (max-width: 768px) {
      padding: 12px 20px;
      margin-top: 25px;
    }
  }

  &__close{
    @media screen and (max-width: 767px) {
      top: 24px;
      right: 12px;
    }
  }

  &__closeBtn:hover {
    background: #F0AB00;
    border: 1px solid #3C1053;
    color: #3c1053;
  }
}
</style>